<template>
  <div class="board-search">
    <input
      type="text"
      class="search__input"
      :placeholder="placeholder"
      v-model="searchText"
      @input="handleInput"
      @keyup.enter="handleSearch"
    >
    <button
      class="search__btn"
      type="button"
      aria-label="검색"
      @click="handleSearch"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'BoardSearch',
  props: {
    placeholder: {
      type: String,
      default: '검색어를 입력하세요'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchText: this.value
    };
  },
  watch: {
    value(newVal) {
      this.searchText = newVal;
    }
  },
  methods: {
    handleInput() {
      this.$emit('input', this.searchText);
    },
    handleSearch() {
      this.$emit('search', this.searchText);
    }
  }
};
</script>

<style scoped lang="scss">
.board-search {
  position: relative;
}

.search__input {
  font-size: 24.93px;
  line-height: 100%;
  letter-spacing: -0.75px;
  vertical-align: middle;
  width: 100%;
  padding: 0 0 18px 0;
  border-bottom: 1px solid #DEDEDE;
}

.search__btn {
  position: absolute;
  bottom: 3px;
  right: 8px;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  cursor: pointer;
  background-image: url("../assets/icons/search-icon.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 32px 32px;
}

// =========================================================================
// 모바일 반응형 (768px 이하)
// =========================================================================
@media (max-width: 768px) {
  .search__input {
    font-size: 16px;  // iOS 줌 방지
    padding: 12px 48px 12px 0;
    min-height: 48px;
  }

  .search__btn {
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
    min-width: 44px;
    min-height: 44px;
    right: 0;
    bottom: 50%;
    transform: translateY(50%);
  }
}
</style>
